export default __webpack_public_path__ + "static/media/about-curve.19046a59.svg";